import styled from 'styled-components'
export const CalendarVerticalCenter = styled.div`
  position: absolute; 
  top: 50%; 
  transform: translateY(-50%);
  width: 100%;
`
export const CalendarCenter = styled.div`
`
export const CalendarBox = styled.div`
color: black;
margin: 45px 0px;
border-radius: 0px;
background-color: white;
overflow: hidden;
border: 1px solid rgba(0, 0, 0, 0.15);
`

export const GolfCourses = styled.div`
  padding: 0px;
  flex: 1;
  overflow: hidden;
  text-align: center;
`

export const WhiteUnderlineHover = styled.a`
  &:hover {
    color: white;
  }
`

export const GolfCourseHeading = styled.h4`
  @media (max-width: 1788px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

export const DateHeading = styled.div`
  overflow: hidden;
  background-color: ${props => props.color};
  text-align: center;
`
DateHeading.defaultProps = {
  color: "#D9B67B"
}

export const WeekNavigatorModal = styled.div`
  overflow: hidden;
  background-color: #D9B67B;
  text-align: center;
  align-content: center;
`

const BookedSlot = styled.p`
  margin: 0px;
  opacity: 1;
  text-align: center;
  color: ${props => props.color};
  overflow: hidden;
`
BookedSlot.defaultProps = {
  color: "white"
}
export { BookedSlot }

export const SlotDate = styled.p`
  @media (min-width: 768px) {
    display: none;
  }
  font-size: 16px;
  opacity: 1;
  color: ${props => props.color};
  text-align: left;
  overflow: hidden;
`
SlotDate.defaultProps = {
  color: "#414141"
}

export const FreeSlots = styled.p`
  @media (max-width: 768px) {
    font-size: 16px;
  }
  margin-top: ${props => props.marginTop}px;
  opacity: 1;
  font-size: 20px;
  text-transform: uppercase;
  color: ${props => props.color};
  text-align: center;
`
FreeSlots.defaultProps = {
  color: "#414141",
  marginTop: 55
}

export const MobileFreeSlots = styled.p`
  @media (max-width: 350px) {
    font-size: 12px;
  }
  margin: 8px;
  opacity: 1;
  font-size: 16px;
  text-align: center;
  color: ${props => props.color};
`
MobileFreeSlots.defaultProps = {
  color: "#414141"
}

const BookingSlot = styled.div`
  border: 5px solid white;
  margin: 0px;
  padding: 5px;
  height: ${props => props.height}px;
  background-color: ${props => props.color};
  overflow: hidden;
`
BookingSlot.defaultProps = {
  height: 120,
  color: "#F6F6F6"
}
export { BookingSlot }


// WEBPACK FOOTER //
// /src/components/internal/BookingCalendarStyle.js